import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";
import { QueryKeys, QueryTimes } from "~/application/constants";
import { travelAnalyticsService } from "~/application/usecases/TravelAnalytics";
import { logError } from "~/presentation/shared/utils/errors";
import { TravelAnalyticsFilters } from "../types";

const LOG_TAG = "Customer/CustomerDashboardBIV2Page/hooks/useCostCenterAnalytics";

interface UseCostCenterAnalyticsProps {
  queryFilters: TravelAnalyticsFilters & { customerUuid: string };
}

export const useCostCenterAnalytics = ({ queryFilters }: UseCostCenterAnalyticsProps) => {
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [search, setSearch] = useState("");
  const [debouncedSearch] = useDebounce(search, 700);

  useEffect(() => {
    setPage(1);
  }, [
    debouncedSearch,
    queryFilters.customerUuid,
    queryFilters.fromYearMonth,
    queryFilters.toYearMonth,
    queryFilters.productType,
  ]);

  const enabled = !!queryFilters.customerUuid;

  const { data, isFetching, isError, error } = useQuery({
    queryKey: [QueryKeys.TA_BY_COST_CENTER, queryFilters, page, pageSize, debouncedSearch],
    queryFn: () =>
      travelAnalyticsService.getByCostCenter({
        ...queryFilters,
        page,
        pageSize,
        search: debouncedSearch,
      }),
    staleTime: QueryTimes.NORMAL,
    enabled,
    keepPreviousData: true,
    onError: (err: Error) => {
      logError({
        logTag: LOG_TAG,
        error: err,
        defaultErrorMessage: "Erro ao buscar dados de gastos por centro de custo",
      });
    },
  });

  return {
    data,
    isFetching,
    error,
    isError,
    page,
    setPage,
    search,
    setSearch,
  };
};
